module.exports = __webpack_public_path__ + "media/assets/Xmark-fd01eb69ed7d3671b6ad53956853dd30.svg";